import { createContext } from 'react';
import { HelpPreference } from '@models/help-preference.model';

export interface HelpPreferenceContextType {
  helpPreference: HelpPreference | undefined;
  setOrUpdatePreference: (
    helpPreference: HelpPreference,
    callback: VoidFunction,
  ) => void;
}

export const HelpPreferenceContext = createContext<HelpPreferenceContextType>({
  helpPreference: undefined,
  setOrUpdatePreference: (
    helpPreference: HelpPreference,
    callback: VoidFunction,
  ) => {},
});
